export const getValue = (obj, path) => {
  if (!obj || !path) return "";

  const parts = path.split(".");
  const first = parts[0];
  const rest = parts.slice(1);

  const val = obj[first];

  // Handle array case: SafetyChecks.CheckPoints
  if (Array.isArray(val) && rest.length > 0) {
    return val
      .map(item => {
        const nested = rest.reduce((acc, key) => (acc ? acc[key] : ""), item);
        return typeof nested === "object" ? JSON.stringify(nested) : nested;
      })
      .filter(Boolean)
      .join(", ");
  }

  // Fallback for non-array paths
  const finalVal = parts.reduce((acc, key) => (acc ? acc[key] : ""), obj);

  if (Array.isArray(finalVal)) {
    return finalVal.join(", ");
  }

  if (typeof finalVal === "object" && finalVal !== null) {
    return JSON.stringify(finalVal);
  }

  // ✅ Format ISO date strings
  if (
    typeof finalVal === "string" &&
    /^\d{4}-\d{2}-\d{2}T/.test(finalVal)
  ) {
    const date = new Date(finalVal);
    return isNaN(date)
      ? finalVal
      : date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
  }

  return finalVal ?? "";
};
